import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import $ from 'jquery';
import { Animated } from 'react-animated-css';
import { GoogleLogin } from 'react-google-login';
//  ----------------   Form components
import Form from 'react-validation/build/form';
import Button from 'react-validation/build/button';

//  ----------------   Custom Form components & validations
import { Email, Password, required, noSpace, minChar8, email, passwordRegex } from '../formValidation';

import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import facebook from '@fortawesome/fontawesome-free-brands/faFacebookF';
import google from '@fortawesome/fontawesome-free-brands/faGooglePlusG';


import { faUser } from '@fortawesome/fontawesome-free-solid';


import './UserLoginForm.css';
import Recaptcha from 'react-recaptcha';
//var Recaptcha = require('react-recaptcha');
import { translate } from 'react-i18next';

class UserLoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fireRedirect: false,
      captcha:''
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  responseFacebook = (response) => {
    if (!response.id) {
      return;
    }
    if (!response.email) {
      this.props.notifyError("Your email is not publically available");
      return;
    }
    this.signupWithSocialMediaData("FACEBOOK", response.name, response.email, null, response.accessToken);
  }

  responseGoogle = (response) => {

    this.signupWithSocialMediaData("GOOGLE", response.profileObj.name, response.profileObj.email, null, response.accessToken);
  }


  signupWithSocialMediaData(provider, name, email, profilePic, token) {
    const data = { provider, name, email, profilePic, token };
    const url = '/api/v1/login/social'; // social login's api url
    // api call for social logins

    $.ajax({
      url: url,
      type: 'POST',
      data: JSON.stringify(data),
      success: function (res) {

        const resObject = res.response;
        window.localStorage.setItem('authToken', resObject.authToken);
        window.localStorage.setItem('username', resObject.userName);
        window.localStorage.setItem('email', resObject.email);
        window.localStorage.setItem('isEmailVerified', resObject.isEmailVerified);
        const appName = resObject.email.replace("@", "");
        window.localStorage.setItem('wowzaAppName',appName);
        window.localStorage.setItem('streamKey', resObject.id);
        let lng = (resObject.language == 'Portuguese') ? 'Portuguese' : 'English';
        window.localStorage.setItem('locale', lng);
        // if social login was successful then redirect user to dashboard
        this.props.history.push('/dashboard');
      }.bind(this),
      error: function (err) {
        this.props.notifyError(err.responseJSON.message);
      }.bind(this)
    });
  }
  handleSocialLoginFailure = (err) => {
    console.error(err);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    // input field animation code - adds class to current focused input field's parent
    if (value) {
      target.parentElement.classList.add('input--filled');
    } else {
      target.parentElement.classList.remove('input--filled');
    }

    this.setState({
      [name]: value
    });
  }

  callback = () => {
    console.log('Done!!!!');
  }

  verifyCallback = (response) => {
    this.setState({
      captcha:response
    })
    console.log('verifyCallback!!!!', response);
  }

  handleSubmit(event) {
    event.preventDefault();

    // get data from all field in form
    const data = this.form.getValues();
    const url = '/api/v1/normal/login'; // user login api url

    // api call to generate token and apikey and login user to dashboard
    $.ajax({
      url: url,
      type: 'POST',
      data: JSON.stringify(data),
      success: function (res) {
        const obj = res.response;
        for (let key in obj) {
          if (obj.hasOwnProperty(key)) {
            let val = obj[key];
            window.localStorage.setItem(key, val);
          }
        }
        this.props.history.push('/dashboard');
      }.bind(this),
      error: function (err) {
        if(err && err.responseJSON) this.props.notifyError(err.responseJSON.message);
      }.bind(this)
    });
   
  }

  render() {
    return (
      <div>

        <Animated className="form-animation" animationIn="fadeInRight" animationOut="fadeOutLeft" isVisible={true}>
          <Form className="userLoginForm" ref={c => { this.form = c }} onSubmit={this.handleSubmit} noValidate>
            <h2 className="formTitle text-center mt-3">{'Conecte-se'}</h2>
            <div className="form-group mt-4">
            < Email
              required
              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
              id="email"
              name="email"
              autoComplete="off"
              type="email"
              className="input__field input__field--madoka"
              onChange={this.handleInputChange}
              validations={[required, email]}
            />
            </div>
            <div className="form-group">
              <Password
                required
                id="password"
                name="password"
                type="password"
                autoComplete="off"
                minLength="6"
                className="input__field input__field--madoka"
                onChange={this.handleInputChange}
                validations={[noSpace, required, passwordRegex]}/>

              {/* Optional Link Component below... 
          Note: If there is no requirement of Link or any Other Element just below <Password/> input field 
          in entire project then the wrapping "div.form-group" can also be put inside 
        Password Component's Template Located in formValidation.js file*/}
              <Link to="/forgot-password" className="float-right forgotPassword">
                <small>{'Esqueceu a senha'}</small>
              </Link>
            </div>
            <div className="form-group m-0 mt-5 d-flex justify-content-center w-100">
             

            </div>
            <div className="form-group submitGroup text-center">
              
          <Button type="submit" className="btn btn--submit mx-auto">{'Conecte-se'}</Button>
             
            </div>
          </Form>
        </Animated>
      </div>
    );
  }
}

export default (UserLoginForm);



// WEBPACK FOOTER //
// ./src/components/UserLoginForm/UserLoginForm.js